import React, { useEffect } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';
import { SubscriptionTier } from '../../../type';
import { useBreakpointSm } from '../../../utils/breakpoints';
import { ComparePackages } from '../ComparePackages';
import { Header } from '../Header';
import { SubscriptionDrawer } from '../SubscriptionDrawer';
import { useResellingProgramsContext } from '../../context';
import { useSubscriptionDrawer } from '../../hooks';
import { ProductListingHeader } from '../ProductListingHeader';
import { PackageDetails } from '../PackageDetails';
import { reportPageViewResellingPlans } from '../../../events/bianka';

export const ProductListing = () => {
    const isSmBreakpoint = useBreakpointSm();

    const { isOpenSubscriptionDrawer, onOpenSubscriptionDrawer, onCloseSubscriptionDrawer } = useSubscriptionDrawer();

    const {
        resellingPrograms: { sellerId },
        pricingDetails,
        selectedTierState: { onChangeTier },
    } = useResellingProgramsContext();

    const handleChooseTier = (tierName: SubscriptionTier) => {
        onChangeTier(tierName);

        onOpenSubscriptionDrawer();
    };

    useEffect(() => {
        reportPageViewResellingPlans({
            sellerId,
            buyerId: getContext().userId,
        });
    }, [sellerId]);

    return (
        <Stack direction="column" rowGap="10">
            <Header />
            <ProductListingHeader />
            {pricingDetails && (
                <Stack direction="column" rowGap="28">
                    <PackageDetails pricingDetails={pricingDetails} onBuyPackage={handleChooseTier} />

                    {isSmBreakpoint && (
                        <ComparePackages pricingDetails={pricingDetails} onChooseTier={handleChooseTier} />
                    )}
                </Stack>
            )}

            <SubscriptionDrawer isOpenDrawer={isOpenSubscriptionDrawer} onCloseDrawer={onCloseSubscriptionDrawer} />
        </Stack>
    );
};
